import React, { useState, useEffect } from 'react';
import { Modal, Row, Col, Form, Button } from "react-bootstrap";
import { getFormDetailsAction } from "../../../Action/admin.action";
import propertise from '../../../config/properties';
import "react-toastify/dist/ReactToastify.css";
import { decryptData } from "../../admin/decrypt";
import toast from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";

const MedpasFormModel = ({ formId, isOpenRxFormModel, handleClose, handleSubmitMedpasDetail }) => {
  const [formDetails, setFormDetails] = useState([]);
  const [formData, setFormData] = useState({});
  const [selectedOption, setSelectedOption] = useState("");
  const [schedulingData, setSchedulingData] = useState({ time: "", days: [] });
  const [times, setTimes] = useState([""]);

  const addTimeField = () => {
    setTimes([...times, ""]);
  };

  const removeTimeField = (index) => {
    const updatedTimes = times.filter((_, i) => i !== index);
    setTimes(updatedTimes);
  };

  const handleInputChange = (index, event) => {
    const updatedTimes = [...times];
    updatedTimes[index] = event.target.value;
    setTimes(updatedTimes);
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setSelectedOption(value);
    handleChange(e);
  };

  const handleChange = (e) => {
    const { name, value, checked } = e.target;

    if (name === "schedulingTime") {
      setSchedulingData({ ...schedulingData, time: value });
    } else if (name === "schedulingDays") {
      if (checked) {
        setSchedulingData({ ...schedulingData, days: [...schedulingData.days, value] });
      } else {
        setSchedulingData({ ...schedulingData, days: schedulingData.days.filter(day => day !== value) });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = () => {
    if (Object.keys(formData).length <= 0) {
      toast.error('Please fill the form');
      return;
    }

    if (!formData['Physician Name']) {
      toast.error('Physician name field is required');
      return;
    }

    if (!formData['Rx start date']) {
      toast.error('Rx start date field is required');
      return;
    }

    if (!formData['Rx start time']) {
      toast.error('Rx start time field is required');
      return;
    }

    if (!formData['Rx cut date']) {
      toast.error('Rx cut date field is required');
      return;
    }

    if (!formData['Rx cut time']) {
      toast.error('Rx cut time field is required');
      return;
    }

    if (formData['Rx start date'] > formData['Rx cut date']) {
      toast.error('Rx start date should be less than cut date');
      return;
    }

    // if (!formData['Scheduling']) {
    //   toast.error('Scheduling field is required');
    //   return;
    // }

    if (!formData['Administering Time']) {
      toast.error('Administering time field is required');
      return;
    }

    if (times) {
      if (formData['Administering Time'] == "Frequency") {
        formData.administeringCustomTimes = []
      } else {
        formData.administeringCustomTimes = JSON.stringify(times)
        formData.administeringFrequencyTimes = ''
      }
    }

    if (formData['Administering Time'] == "Custom Time" && formData.administeringCustomTimes.length <= 0) {
      toast.error('Custom time field is required');
      return;
    }

    if (formData['Scheduling'] == "Daily" || formData['Scheduling'] == "Once a month" || formData['Scheduling'] == "By Hourly" || formData['Scheduling'] == "By Days") {
      schedulingData.days = []
    }

    if (formData['Scheduling'] == "By Hourly" || formData['Scheduling'] == "By Days") {
      schedulingData.days = []
      schedulingData.time = ""
    } else {
      formData.schedulingTimeByHrsDays = ''
    }

    if (formData['Administering Time'] == "Frequency") {
      formData.administeringCustomTimes = []
    } else {
      formData.administeringFrequencyTimes = ''
    }

    const updatedFormData = {
      ...formData,
      SchedulingData: JSON.stringify(schedulingData),
    };

    handleSubmitMedpasDetail(updatedFormData);
  };

  useEffect(() => {
    getFormDetailsAPI();
  }, []);

  const getFormDetailsAPI = async () => {
    let res = await getFormDetailsAction({ id: propertise.medPassFormId });
    if (res.success) {
      setFormDetails(decryptData(res.data));
    }
  };

  return (
    <>
      <Modal show={isOpenRxFormModel} className='modal-lg' onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Medpas details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="reportTitle" className='mt-2'>
              <Row>
                <Col lg={12} md={12} sm={12}>
                  <div className="formDiv">
                    <Form>
                      <Row className="mb-4 d-flex justify-content-center">
                        {formDetails.length > 0
                          ? formDetails
                            .filter((item) => {
                              if (
                                formData["Medication Type"] === "Medication PRN" &&
                                (item.fieldName === "Scheduling" || item.fieldName === "Administration time") ||
                                formData["Ancillary Type"] === "Ancillary PRN" &&
                                (item.fieldName === "Scheduling" || item.fieldName === "Administration time") ||
                                (formId == propertise.ancillaryFormId && (item.id === propertise.rxFormMedicationDropdown)) ||
                                formId == propertise.medPassDrugFormId && (item.id === propertise.rxFormAncillaryDropdown)
                              ) {
                                return false;
                              }
                              return true;
                            })
                            .map((item) => (
                              <div className="col-md-6 mt-3" key={item.id}>
                                {item.fieldtype === "selectManual" ? (
                                  <>
                                    {item.id == propertise.schedulingFieldIdForMedpass ? // scheduling dropdown 
                                      <Form.Group as={Col} controlId="formGridEmail">
                                        <label>{item.fieldName}</label>
                                        {JSON.parse(item.radioCheckboxValue).length > 0 && (
                                          <select
                                            className="form-control"
                                            name={item.fieldName}
                                            value={formData[item.fieldName] || ""}
                                            onChange={handleSelectChange}
                                          >
                                            <option value="">-Select-</option>
                                            {JSON.parse(item.radioCheckboxValue).map((radioData) => (
                                              <option key={radioData} value={radioData}>
                                                {radioData}
                                              </option>
                                            ))}
                                          </select>
                                        )}
                                      </Form.Group>

                                      :

                                      <Form.Group as={Col} controlId="formGridEmail">
                                        <label>{item.fieldName}</label>
                                        {JSON.parse(item.radioCheckboxValue).length > 0 && (
                                          <select
                                            className="form-control"
                                            name={item.fieldName}
                                            value={formData[item.fieldName] || ""}
                                            onChange={handleChange}
                                          >
                                            <option value="">-Select-</option>
                                            {JSON.parse(item.radioCheckboxValue).map((radioData) => (
                                              <option key={radioData} value={radioData}>
                                                {radioData}
                                              </option>
                                            ))}
                                          </select>
                                        )}
                                      </Form.Group>
                                    }
                                  </>
                                ) : (
                                  <Form.Group as={Col} controlId="formGridEmail">
                                    <label>{item.fieldName}</label>
                                    <Form.Control
                                      onChange={handleChange}
                                      type={item.fieldtype}
                                      name={item.fieldName}
                                      placeholder={`Enter ${item.fieldName}`}
                                    />
                                  </Form.Group>
                                )}
                              </div>
                            ))
                          : ""}
                      </Row>

                      <Row>
                        {formData['Administering Time'] === "Custom Time" &&
                          <>
                            <Form.Group as={Col} controlId="formGridEmail">
                              <div className="time-picker">
                                <label>Number Of Times:</label>
                                <br />
                                {times.map((time, index) => (
                                  <div key={index} className="d-flex mb-2">
                                    <input
                                      type="time"
                                      name={`schedulingTimeByHrsDays-${index}`}
                                      className="form-control"
                                      value={time}
                                      onChange={(event) => handleInputChange(index, event)}
                                    />
                                    {times.length > 1 &&
                                      <Button
                                        variant="danger"
                                        onClick={() => removeTimeField(index)}
                                        className="ms-2"
                                        size="sm"
                                      > ❌ </Button>
                                    }
                                  </div>
                                ))}
                                <Button
                                  variant="primary"
                                  onClick={addTimeField}
                                  className="mt-2"
                                  size="sm"
                                >
                                  Add More
                                </Button>
                              </div>
                            </Form.Group>
                          </>
                        }

                        {formData['Administering Time'] === "Frequency" &&
                          <>
                            <Form.Group as={Col} controlId="formGridEmail">
                              <div className="time-picker">
                                <label>Number Of Times:</label><br />
                                <input
                                  type="text"
                                  name="administeringFrequencyTimes"
                                  placeholder={`Enter number of times`}
                                  className='form-control'
                                  onChange={handleChange}
                                />
                              </div>
                            </Form.Group>
                          </>
                        }
                      </Row>

                      {/* Conditional rendering based on selected option */}
                      <Row>
                        {(selectedOption === "By Hourly" || selectedOption === "By Days") && (
                          <Form.Group as={Col} controlId="formGridEmail">
                            <div className="time-picker">
                              <label>{selectedOption}:</label><br />
                              <input
                                type="text"
                                name="schedulingTimeByHrsDays"
                                placeholder={`Ex: ${selectedOption === "By Hourly" ? 'After 4 Hrs' : 'After 2 Days'}`}
                                className='form-control'
                                onChange={handleChange}
                              />
                            </div>
                          </Form.Group>
                        )}

                        {(selectedOption === "Once a month") && (
                          <Form.Group as={Col} controlId="formGridEmail">
                            <div className="time-picker">
                              <label>Select Date:</label><br />
                              <input
                                type="date"
                                name="schedulingDate"
                                className='form-control'
                                onChange={handleChange}
                              />
                            </div>
                          </Form.Group>
                        )}

                        {(selectedOption === "Daily" || selectedOption === "Alternate days" || selectedOption === "Weekdays" || selectedOption === "Once a week" || selectedOption === "Once in bi weekly" || selectedOption === "Once a month") && (
                          <Form.Group as={Col} controlId="formGridEmail">
                            <div className="time-picker">
                              <label>Select Scheduling Time:</label><br />
                              <input
                                type="time"
                                name="schedulingTime"
                                className='form-control'
                                onChange={handleChange}
                              />
                            </div>
                          </Form.Group>
                        )}

                        {(selectedOption === "Alternate days" || selectedOption === "Weekdays" || selectedOption === "Once a week" || selectedOption === "Once in bi weekly") && (
                          <Form.Group as={Col} controlId="formGridEmail">
                            <div className="alternate-days">
                              <label>Select Days:</label><br />
                              <div className="days-selection">
                                {["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map((day) => (
                                  <label key={day}>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <input
                                      type="checkbox"
                                      name="schedulingDays"
                                      value={day}
                                      checked={schedulingData.days.includes(day)}
                                      onChange={handleChange}
                                    />&nbsp;
                                    {day}
                                  </label>
                                ))}
                              </div>
                            </div>
                          </Form.Group>
                        )}
                      </Row>
                      <br />
                    </Form>
                  </div>
                </Col>
              </Row>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Cancel</Button>
          <Button variant="primary" onClick={handleSubmit}>Submit</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MedpasFormModel;
